import { TableHead, TablePagination } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import * as React from 'react';
import { IAsset, IFeed, IFilters, sort } from '../../models/states';
import { getSorting, stableSort } from '../../utilities/utilities';
import IconDisplay from './../../components/UI/IconDisplay/IconDisplay';
import smilie from './../../static/icons/smilie.svg';
import IngestPodTableHeader from './IngestPodTableHeader';
import IngestPodTableItem from './IngestPodTableItem';
const styles = () =>
  createStyles({
    tableRoot: {
      marginTop: '1rem'
    }
  });

class IngestPodTable extends React.Component<IIngestPodTableProps, {}> {
  renderRow = (asset, index) => {
    const {
      page,
      rowsPerPage,
      onOpenAssetSummary,
      onCloseAssetSummary,
      feedMap
    } = this.props;
    return (
      <IngestPodTableItem
        item={asset}
        index={index + page * rowsPerPage}
        key={index}
        onEscalate={this.props.onEscalate}
        onToggleSelectedAssets={this.props.onToggleSelectedAssets}
        checked={this.props.selectedAssets.indexOf(asset.id) !== -1}
        onOpenAssetSummary={() => onOpenAssetSummary(asset.id)}
        onCloseAssetSummary={() => onCloseAssetSummary(asset.id)}
        feedMap={feedMap}
      />
    );
  };

  renderTablePagination = (
    assets: IAsset[],
    rowsPerPage: number,
    page: number
  ): React.ReactNode => {
    return (
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 150]}
        component="div"
        count={assets.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onChangePage={this.props.onChangePage}
        onChangeRowsPerPage={e => this.props.onChangeRowsPerPage(e)}
      />
    );
  };
  render() {
    const {
      assets,
      rowsPerPage,
      page,
      order,
      orderBy,
      onToggleFilters,
      onRequestSort,
      isOpenFilters,
      filters,
      onToggleHeaderFilters,
      classes
    } = this.props;
    const rows = stableSort(assets, getSorting(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    return assets.length === 0 ? (
      <IconDisplay
        logo={smilie}
        message={'No issues observed in the delivered files!'}
      />
    ) : (
      <div>
        <Table className={classes.tableRoot}>
          <TableHead>
            <IngestPodTableHeader
              order={order}
              orderBy={orderBy}
              onToggleFilters={onToggleFilters}
              onRequestSort={onRequestSort}
              filters={filters}
              isOpenFilters={isOpenFilters}
              onToggleHeaderFilters={onToggleHeaderFilters}
              feedMap={this.props.feedMap}
            />
          </TableHead>
          <TableBody>
            {rows.map((asset: IAsset, index: number) => {
              return this.renderRow(asset, index);
            })}
          </TableBody>
        </Table>
        {this.renderTablePagination(assets, rowsPerPage, page)}
      </div>
    );
  }
}
export interface IIngestPodOwnProps extends WithStyles<typeof styles> {
  assets: IAsset[];
  multiSelect: boolean;
  order: sort;
  orderBy: string;
  page: number;
  rowsPerPage: number;
  onRequestSort: any; // todo: give proper signature
  onToggleFilters: any; // todo: give proper signature
  onChangeRowsPerPage: any;
  onChangePage: any;
  isOpenFilters: any;
  filters: IFilters;
  onToggleHeaderFilters: any;
  onEscalate: any;
  onToggleSelectedAssets: (assets: string[]) => any;
  onFlushSelectedAssets: () => any;
  onCloseAssetSummary: (assetId: string) => any;
  onOpenAssetSummary: (assetId: string) => any;
  selectedAssets: string[];
  feedMap: { [key: string]: IFeed };
}

type IIngestPodTableProps = IIngestPodOwnProps;

export default withStyles(styles)(IngestPodTable);
